import React, { PureComponent } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import "./InspectList.css";
import { getPageDataApi } from "../../api/pages";
import InsSinglePdf from "../InsSinglePdf/InsSinglePdf";

let pageArr = [];
let pageData = {};

const BANNER_HEIGHT = 67;
const PADDING_HEIGHT = 60;

const isItemLoaded = index => {
  const convertedIdx = index * 3;

  if (pageData[pageArr[convertedIdx]] == null) {
    return false;
  }

  if (
    convertedIdx + 1 < pageArr.length &&
    pageData[pageArr[convertedIdx + 1]] == null
  ) {
    return false;
  }

  if (
    convertedIdx + 2 < pageArr.length &&
    pageData[pageArr[convertedIdx + 2]] == null
  ) {
    return false;
  }

  return true;
};

const loadMoreItems = (startIndex, stopIndex) => {
  const convertedStartIdx = startIndex * 3;
  let convertedStopIdx = stopIndex * 3 + 2;

  if (convertedStopIdx >= pageArr.length) {
    convertedStopIdx = pageArr.length - 1;
  }

  const arrToLoad = pageArr.slice(convertedStartIdx, convertedStopIdx + 1);

  return Promise.all(
    arrToLoad.map(pageID => {
      return loadAnItem(pageID);
    })
  );
};

function flatten(pageID) {
  pageData[pageID].should_flatten = true;
}

async function loadAnItem(pageID) {
  try {
    pageData[pageID] = await getPageDataApi(pageID);
  } catch (e) {
    console.log(e.toString());
  }
}

class TwoPageRow extends PureComponent {
  render() {
    const { index, style } = this.props;
    const convertedIdx = index * 3;
    return (
      <Row style={{ ...style, marginLeft: 0, marginRight: 0 }}>
        <Col xs="12" sm="12" md="4" lg="4" xl="4">
          <InsSinglePdf
            page={pageData[pageArr[convertedIdx]]}
            handleFlatten={flatten}
          />
        </Col>
        <Col xs="12" sm="12" md="4" lg="4" xl="4">
          {convertedIdx + 1 < pageArr.length && (
            <InsSinglePdf
              page={pageData[pageArr[convertedIdx + 1]]}
              handleFlatten={flatten}
            />
          )}
        </Col>
        <Col xs="12" sm="12" md="4" lg="4" xl="4">
          {convertedIdx + 2 < pageArr.length && (
            <InsSinglePdf
              page={pageData[pageArr[convertedIdx + 2]]}
              handleFlatten={flatten}
            />
          )}
        </Col>
      </Row>
    );
  }
}

class InspectList extends React.Component {
  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);

    const { issue } = props;
    pageArr = issue.pages.map(obj => obj.id);
    pageData = {};

    if (window.innerWidth < 768) {
      this.state = {
        windowHeight: window.innerHeight,
        itemHeight: PADDING_HEIGHT * 3 + window.innerWidth * 4
      };
    } else {
      this.state = {
        windowHeight: window.innerHeight,
        itemHeight: PADDING_HEIGHT + (window.innerWidth * 4) / 3 / 3
      };
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (window.innerWidth < 768) {
      this.setState({
        windowHeight: window.innerHeight,
        itemHeight: PADDING_HEIGHT * 3 + window.innerWidth * 4
      });
    } else {
      this.setState({
        windowHeight: window.innerHeight,
        itemHeight: PADDING_HEIGHT + (window.innerWidth * 4) / 3 / 3
      });
    }
  }

  render() {
    return (
      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        itemCount={Math.ceil(pageArr.length / 3)}
        loadMoreItems={loadMoreItems}
      >
        {({ onItemsRendered, ref }) => (
          <List
            className="List"
            height={this.state.windowHeight - BANNER_HEIGHT}
            itemCount={Math.ceil(pageArr.length / 3)}
            itemSize={this.state.itemHeight}
            ref={ref}
            onItemsRendered={onItemsRendered}
            width={"100%"}
          >
            {TwoPageRow}
          </List>
        )}
      </InfiniteLoader>
    );
  }
}

export default InspectList;
